import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/tickets',
      name: 'tickets',
      // route level code-splitting
      // this generates a separate chunk (tickets.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "tickets" */ './views/Tickets.vue')
    },
    {
      path: '/ordercalendar',
      name: 'ordercalendar',
      component: () => import(/* webpackChunkName: "orderCalendar" */ './views/OrderCalendar.vue')
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "faq" */ './views/FaqList.vue')
    },
    {
      path: '/ticketlist',
      name: 'ticketlist',
      component: () => import(/* webpackChunkName: "tickets" */ './views/TicketTable.vue')
    },
    {
      path: '/rating',
      name: 'Rating',
      component: () => import(/* webpackChunkName: "rating" */ './views/Rating.vue')
    },
    {
      path: '/announcement',
      name: 'Announcement',
      component: () => import(/* webpackChunkName: "announcement" */ './views/Announcement.vue')
    },
    {
      path: '/charts',
      name: 'Charts',
      component: () => import(/* webpackChunkName: "charts" */ './views/Charts.vue')
    },
    {
      path: '/jsonedit',
      name: 'JsonEdit',
      component: () => import(/* webpackChunkName: "jsonedit" */ './views/JsonEdit.vue')
    },
    {
      path: '/booking/calendar',
      name: 'Calendar',
      component: () => import(/* webpackChunkName: "booking" */ './views/BookingSystem/Calendar.vue')
    },
    {
      path: '/ordermonthlycalendar',
      name: 'ordermonthlycalendar',
      component: () => import(/* webpackChunkName: "ordermonthlycalendar" */ './views/OrderMonthlyCalendar.vue')
    },
    {
      path: '/hexagon',
      name: 'hexagon',
      component: () => import(/* webpackChunkName: "hexagon" */ './views/Hexagon.vue')
    },
    {
      path: '/filtertest',
      name: 'filtertest',
      component: () => import(/* webpackChunkName: "filtertest" */ './views/FilterTest.vue')
    },
    {
      path: '/catering',
      name: 'caterinLogin',
      component: () => import(/* webpackChunkName: "catering" */ './views/Catering/views/Login.vue')
    },
    {
      path: '/catering/home',
      name: 'cateringHomeScreen',
      component: () => import(/* webpackChunkName: "catering" */ './views/Catering/views/Home.vue')
    },
    {
      path: '/catering/signout',
      name: 'cateringSignOut',
      component: () => import(/* webpackChunkName: "catering" */ './views/Catering/views/SignOut.vue')
    },
    {
      path: '/barcode-scanner',
      name: 'barCodeScanner',
      component: () => import(/* webpackChunkName: "catering" */ './views/BarCodeScanner.vue')
    },
    {
      path: '/report',
      name: 'reportControl',
      component: () => import(/* webpackChunkName: "reportcontrol" */ './views/Report/index.vue')
    },
  ]
})
